import React, { useEffect } from 'react'

import { MY_TEAMS_ADVISOR } from '@zet/constants'
import { Icon, Pressable, SH3 } from '@zet/design-system'
import { Stack } from '@zet/design-system/layout'
import { APP_NAME } from '@zet/end-points'
import Shimmer from '@zet/svg/Shimmer.svg'
import { DEVICE_WIDTH } from '@zet/utils/Constants'
import { LinearGradient } from 'expo-linear-gradient'
import Animated, {
  useAnimatedStyle,
  useSharedValue,
  withDelay,
  withRepeat,
  withTiming,
} from 'react-native-reanimated'

import { LivePulse } from '../livePulse'

const SHIMMER_WIDTH = 54

interface IProps {
  showStrip?: boolean
  msg: string
  onPress: () => void
}
export const LiveCampaignStrip: React.FC<IProps> = ({
  showStrip = false,
  msg,
  onPress,
}) => {
  const translateX = useSharedValue(-SHIMMER_WIDTH)

  // Animate the shimmer effect
  useEffect(() => {
    translateX.value = withRepeat(
      withDelay(
        1200,
        withTiming(DEVICE_WIDTH, {
          duration: 1200,
        })
      ),
      -1
    )
  }, [])

  const animatedStyle = useAnimatedStyle(() => ({
    transform: [{ translateX: translateX.value }],
  }))

  const handleOnPress = () => {
    if (onPress) {
      onPress()
    }
  }

  if (!showStrip) return <></>

  if (APP_NAME === MY_TEAMS_ADVISOR) {
    return null
  }

  return (
    <Stack className="relative">
      <LinearGradient
        colors={[
          '#010C2C',
          '#010C2C',
          '#ffffff',
          '#ffffff',
          '#FBF3FF',
          '#FBF3FF',
        ]}
        locations={[0, 0.25, 0.25, 0.256, 0.256, 1]}
        start={{ x: 0, y: 0 }}
        end={{ x: 0.98, y: 2.5 }}
      >
        <Pressable
          onPress={handleOnPress}
          className="mx-2 h-[36px] flex-row items-center self-center py-2"
        >
          <Stack className="w-[25%] flex-row items-center">
            <LivePulse />
            <SH3 className={'text-neutral-white100 ml-1'}>Live Offer</SH3>
          </Stack>
          <Stack className={'w-[75%] flex-row justify-between'}>
            <SH3
              style={{
                color: '#832DC2',
              }}
              className="pl-2"
            >
              {msg}
            </SH3>
            <Icon type={'InfoOutlined'} color={'#832DC2'} size={20} />
          </Stack>
        </Pressable>
      </LinearGradient>
      <Animated.View className={'absolute left-0 top-0'} style={animatedStyle}>
        <Shimmer />
      </Animated.View>
    </Stack>
  )
}